const columnArr = [
  {
    name: 'SHOP id',
    keywords: 'sid'
  },
  {
    name: 'START TIME',
    keywords: 'starttime'
  },	
  {
    name: 'END TIME',
    keywords: 'endtime'
  },
  {
    name: 'STAY TIME',
    keywords: 'staytime'
  },
  {
    name: 'Language',
    keywords: 'lang'
  },
  {
    name: 'Caliber_101',
    keywords: 'calibre1'
  },
  {
    name: 'Overview_101',
    keywords: 'calibre1ov'
  },
  {
    name: 'Function_101',
    keywords: 'calibre1fn'
  },
  {
    name: 'Related_101',
    keywords: 'calibre1rw'
  },
  {
    name: 'Game_101',
    keywords: 'calibre1gm'
  },
  {
    name: 'Story_101',
    keywords: 'calibre1st'
  },
  {
    name: 'Caliber_854A/2',
    keywords: "calibre2"
  },
  {
    name: 'Overview_854A/2',
    keywords: 'calibre2ov'
  },
  {
    name: 'Function_854A/2',
    keywords: 'calibre2fn'
  },
  {
    name: 'Related_854A/2',
    keywords: 'calibre2rw'
  },
  {
    name: 'Game_854A/2',
    keywords: 'calibre2gm'
  },
  {
    name: 'Story_854A/2',
    keywords: 'calibre2st'
  },
  {
    name: 'Caliber_978G',
    keywords: 'calibre5'
  },
  {
    name: 'Overview_978G',
    keywords: 'calibre5ov'
  },
  {
    name: 'Function_978G',
    keywords: 'calibre5fn'
  },
  {
    name: 'Related_978G',
    keywords: 'calibre5rw'
  },
  {
    name: 'Game_978G',
    keywords: 'calibre5gm'
  },
  {
    name: 'Story_978G',
    keywords: 'calibre5st'
  },
  {
    name: 'Caliber_956AA',
    keywords: 'calibre4'
  },
  {
    name: 'Overview_956AA',
    keywords: 'calibre4ov'
  },
  {
    name: 'Function_956AA',
    keywords: 'calibre4fn'
  },
  {
    name: 'Related_956AA',
    keywords: 'calibre4rw'
  },
  {
    name: 'Game_956AA',
    keywords: 'calibre4gm'
  },
  {
    name: 'Story_956AA',
    keywords: 'calibre4st'
  },
  {
    name: 'Caliber_868',
    keywords: 'calibre3'
  },
  {
    name: 'Overview_868',
    keywords: 'calibre3ov'
  },
  {
    name: 'Function_868',
    keywords: 'calibre3fn'
  },
  {
    name: 'Related_868',
    keywords: 'calibre3rw'
  },
  {
    name: 'Game_868',
    keywords: 'calibre3gm'
  },
  {
    name: 'Story_868',
    keywords: 'calibre3st'
  }
]

export default columnArr


// WEBPACK FOOTER //
// ./src/date/date.js